var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInActiveFavouriteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6188 1.60167C14.1533 0.799444 12.9948 0.799441 12.5293 1.60167L9.25099 7.25141C9.02103 7.6477 8.62357 7.91814 8.17053 7.98657L2.02676 8.91451C0.994867 9.07037 0.632908 10.3732 1.43653 11.039L6.01339 14.8309C6.43705 15.1819 6.63626 15.7356 6.53334 16.276L5.33611 22.5633C5.14685 23.5572 6.19022 24.3294 7.08546 23.8581L12.8706 20.812C13.3109 20.5801 13.8372 20.5801 14.2775 20.812L20.0627 23.8581C20.9579 24.3294 22.0013 23.5572 21.812 22.5633L20.6148 16.276C20.5119 15.7356 20.7111 15.1819 21.1347 14.8309L25.7116 11.039C26.5152 10.3732 26.1533 9.07037 25.1214 8.91451L18.9776 7.98657C18.5245 7.91814 18.1271 7.6477 17.8971 7.25141L14.6188 1.60167Z",
    stroke: "#FFBE81",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInActiveFavouriteIcon);
export default __webpack_public_path__ + "static/media/InActiveFavouriteIcon.c4233f503f9496897f7e75202dffa383.svg";
export { ForwardRef as ReactComponent };